module.exports = __webpack_public_path__ + "img/ico_cerrar_pizzas.06d991ee.svg";